const setLateraMenuOpen = (context, isLateralMenuOpen) => {
  context.commit('IS_LATERAL_MENU_OPEN', isLateralMenuOpen);
};

export default {
  setLateraMenuOpen,
};
